module.exports = __webpack_public_path__ + "img/plus-grey.6943163e.svg";